import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { getQuoteLineOrThrow } from '../utilities/action-guards';
import { validateCustomerPartId } from '../validations/customer-part-id';
import { QuoteLineParams } from './types';

interface Params extends QuoteLineParams {
  customerPartId: string;
}

export function customerPartIdChanged(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<Params>,
) {
  const quoteLine = getQuoteLineOrThrow(state, action.payload.quoteLineUuid);

  const customerPartId = validateCustomerPartId(state, {
    customerPartId: action.payload.customerPartId,
    quoteLineUuid: action.payload.quoteLineUuid,
  });

  quoteLine.customerPartId = customerPartId;
}
